bcn.chart = (function () {

  'use strict';

  function drawChart(chart) {
    var percentage = $(chart).data('chart-value');
    var chartValue = percentage >= 100 ? 100 : percentage;

    var data = [
      {
          value: chartValue,
          color:'#F56A00',
          label: 'Progress'
      },
      {
          value: 100 - chartValue,
          color: '#EEE'
      }
    ];

    var options = {
      segmentStrokeWidth : 1,
      percentageInnerCutout : 70,
      showTooltips: false,
      responsive: true
    };

    var ctx = chart.getContext('2d');
    var myDoughnutChart = new Chart(ctx).Doughnut(data,options);
  }


  return {
    init: function () {
      var chart = document.getElementById('progress_chart');

      if (!chart ) {
        return;
      }

      drawChart(chart);

    }
  };

})();
